var { config } = window;
jQuery(document).ready(function($) {
	function animateOnScroll() {
		var scrollHeight = $(window).scrollTop() + ($(window).height() * config.animation.windowProportion);

		$('.animate-container').each(function(i, el) {
			var $el = $(el);

			if ($el.hasClass('animate-intro')) {
				$el.addClass('reveal');
				return;
			}

			if ($el.is(':visible')) {
				if (!isNaN(parseInt($el.css('top')))) {
					var scrollTop = $el.offset().top - parseInt($el.css('top'));
				} else {
					var scrollTop = $el.offset().top;
				}

				if (scrollTop < scrollHeight) {
					$el.addClass('reveal');
				} else {
					if (!$el.hasClass('animate-once')) {
						$el.removeClass('reveal');
					}
				}
			}
		});
	}

	$(window).on('scroll', animateOnScroll);
	$(document).on('tab-changed', animateOnScroll);
	animateOnScroll();
});

/**
* Start action when element in view
* elem = element
* screenPosition = the position of the element on the screen
*/
 function elementScrolled(elem, screenPosition) {
 	var docViewTop = $(window).scrollTop();
 	var docviewHeight = $(window).height();
 	var elemTop = $(elem).offset().top;
 	return elemTop <= docViewTop + (docviewHeight * screenPosition);
 }